import {
    Grid,
    Typography,
    Card,
    CardActionArea,
    CardContent,
    Box
} from '@mui/material';

import HaveAccount from '../../components/onbording/have-account';
import OnBoardingLayout from '../../../theme/templates/on-boarding';
import BusinessIcon from '@mui/icons-material/Business';
import PersonIcon from '@mui/icons-material/Person';

import './index.scss'

export default function RegisterGooglePage() {
    return (
        <OnBoardingLayout>
            <Grid
                sx={{
                    maxWidth: '90%',
                    width: '450px',
                }}
            >
                <Typography
                    sx={{ textAlign: 'center', mb: 2 }}
                    component="h1"
                    variant="h2"
                >
                    Almost there!
                </Typography>
                <Typography
                    sx={{ mt: 5, textAlign: 'center' }}
                    component="h2"
                    variant="body1"
                >
                    To complete your registration, we need you to provide some additional information.
                </Typography>
                <Typography
                    sx={{ mt: 2, textAlign: 'center' }}
                    component="h2"
                    variant="body1"
                >
                    Please choose the profile type that best fist your role.
                </Typography>
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'space-evenly',
                        marginY: 5,
                    }}
                >
                    <Card
                        sx={{
                            backgroundColor: 'white',
                            width: '200px',
                            boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px;"
                        }}
                    >
                        <CardActionArea
                            href="/register-google/company"
                            sx={{
                                height: '100%'
                            }}
                        >
                            <CardContent
                                sx={{
                                    textAlign: 'center',
                                    paddingY: '25px',
                                }}
                            >
                                <BusinessIcon
                                    sx={{
                                        fontSize: '3rem',
                                        marginY: '1rem',
                                        color: '#feb100',
                                    }}
                                />
                                <Typography
                                    component='h1'
                                    variant='h4'
                                    sx={{
                                        marginBottom: '1rem'
                                    }}
                                >
                                    Company
                                </Typography>
                                <Typography
                                    component='h1'
                                    variant='body2'
                                >
                                    Enroll as a Company if you represent a production company or
                                    ad agency and want to gain access to our tools and features
                                </Typography>
                            </CardContent>
                        </CardActionArea>
                    </Card>
                    <Card
                        sx={{
                            backgroundColor: 'white',
                            width: '200px',
                            boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px;"
                        }}
                    >
                        <CardActionArea
                            href="/register-google/person"
                        >
                            <CardContent
                                sx={{
                                    textAlign: 'center',
                                    paddingY: '25px'
                                }}
                            >
                                <PersonIcon
                                    sx={{
                                        fontSize: '3rem',
                                        marginY: '1rem',
                                        color: '#feb100',
                                    }}
                                />
                                <Typography
                                    component='h1'
                                    variant='h4'
                                    sx={{
                                        marginBottom: '1rem'
                                    }}
                                >
                                    Person
                                </Typography>
                                <Typography
                                    component='h1'
                                    variant='body2'
                                >
                                    Enroll as a Person if you are a producer or crew member looking to create
                                    a profile and utilize our platform's tools for your projects.
                                </Typography>
                            </CardContent>
                        </CardActionArea>
                    </Card>
                </Box>
                <Typography
                    sx={{ mb: 1, textAlign: 'center' }}
                    component="h1"
                    variant="body1"
                >
                    Select the option that aligns with your profile type and get ready to harness the power
                    of Cinemahive's tools for your cinematic endeavors!
                </Typography>
            </Grid>
            <HaveAccount />
        </OnBoardingLayout>
    );
}
